import { Component, Prop, Watch } from "vue-property-decorator";
import { InputMessage, InputOption } from "../../../../../models/Input";
import InputDefaultForm from "../../../default/InputDefaultForm";

@Component
export default class InputDecimalForm extends InputDefaultForm {
	@Prop()
	public dataInputOption!: InputOption;

	public mounted(): void {
		this.dataInputOption.max = 15;
	}

	@Watch("dataInputOption.trigger")
	public checkValidation(): void {
		this.checkValidationDefault();

		if (this.dataInputOption.error) {
			return;
		}

		if (this.dataInputOption.vmodel !== "") {
			this.success = false;
			this.dataInputOption.error = false;
			const decimalRegex = new RegExp("^[0-9]{1,9}([\.][0-9]{1,2})?$", "g");

			if (decimalRegex.test(this.dataInputOption.vmodel)) {
				this.success = true;
			} else {
				this.dataInputOption.error = true;
				this.dataInputOption.message = InputMessage.DecimalInvalid;
			}
		}
	}

	public keyup(e: any): void {
		e.target.value = e.target.value.replace(",", ".");
		this.dataInputOption.vmodel = e.target.value;

		this.$emit("changed");
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/forms/extended/InputNumber/InputDecimalForm/InputDecimalForm.ts